<template>
  <ul class="user-menu">
    <li class="user-menu__item">
      <router-link 
        :to="{name: 'torneos-user-mios'}"
        class="user-menu__item__link">Mis Competiciones
      </router-link>
    </li>
    <li class="user-menu__item">
      <router-link 
        :to="{name: 'equipos-user-mios'}"
        class="user-menu__item__link">Mis Equipos
      </router-link>
    </li>
    <li class="user-menu__item">
      <router-link 
        :to="{name: 'user-ivitations'}"
        class="user-menu__item__link">Invitaciones
      </router-link>
    </li>
    <li class="user-menu__item">
      <router-link 
        :to="{name: 'user-mi-perfil', params: {'username': dataUser.username}}" 
        class="user-menu__item__link">
        Editar Perfil
      </router-link>
    </li>
    <li class="user-menu__item">
      <router-link 
        :to="{name: 'user-products'}" 
        class="user-menu__item__link">
        Productos Comprados
      </router-link>
    </li>
    <li class="user-menu__item">
      <router-link 
        :to="{name: 'user-ads-compe'}" 
        class="user-menu__item__link">
        Mis Anuncios
      </router-link>
    </li>
    <li class="menu-user__item">
      <a 
        href="https://deporstarservicios.blogspot.com/2023/04/terminos-y-condiciones-deporstar.html"
        target="_blank" 
        class="user-menu__item__link">Terminos y privacidad</a>
    </li>
    <li class="menu-user__item">
      <router-link :to="{name: 'login'}" class="user-menu__item__link red">Cerrar sesion</router-link>
    </li>
  </ul>
</template>

<script>
  //
  import { mapGetters } from 'vuex'
  
  export default {
    name: 'PerfilUserMenu',
    computed: {
      ...mapGetters({
        dataUser: 'dataUser'
      })
    },
  }
</script>

<style lang="scss" scoped>
  .user-menu {
    background: $color-8;
    display: block;
    width: 120px;
    list-style: none;
    position: absolute;
    top: 45px;
    right: -5px;
    z-index: 200;
    padding: 10px;
    @include desde($large) {
      width: 100%;
      right: 0px;
      top: 50px;
    }
    &__item {
      display: block;
      &__link {
        text-align: left;
        display: block;
        padding-top: 5px;
        padding-bottom: 5px;
        font-size: 14px;
        font-family: $ff-1;
        text-decoration: none;
        color: $color-1;
        width: 100%; // puede ser menos o en px
        white-space: nowrap; // indica que que se muestre en una sola fila
        overflow: hidden; // la parte que se desborda no se muestra
        text-overflow: ellipsis; 
        &.red {
          color: $color-2;
        }
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>